// extracted by mini-css-extract-plugin
export default {"editedSetting":"employeeSettings_editedSetting__z8faj"};